import http from '../httpService';

const ProsecutorOfficeGroupService = {
  getOfficeGroupsService: params => http.get('prosecutor-office-group', { params }),

  getHearingsForProsecutorOfficeGroup: (prosecutorOfficeGroupId, yearMonth) =>
    http.get(`/prosecutor-office-group/${prosecutorOfficeGroupId}/hearings/${yearMonth}`),
};

export default ProsecutorOfficeGroupService;
